module.exports = __webpack_public_path__ + "media/images/common/icon-company-black-26afad5de09e0d93eb34015eecdaae13.png";